import { render, staticRenderFns } from "./CostSubtotalMetricConfigurationPage.vue?vue&type=template&id=7953a0d8"
import script from "./CostSubtotalMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./CostSubtotalMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports